import { connect } from 'react-redux'
import { CustomSnackbar } from './CustomSnackbar'
import { selectNotifications } from '../../selectors/notifications'

export { CustomSnackbarProvider } from './CustomSnackbarProvider'

const mapStateToProps = selectNotifications

export default connect(mapStateToProps)(CustomSnackbar)
